/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_CautionInputs */



/**
* | output |
* | --- |
* | "Caution" |
*
* @param {Sanction_Level_CautionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_caution = /** @type {((inputs?: Sanction_Level_CautionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_CautionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avertissement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Precaución")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Advertência")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvertimento")
	return /** @type {LocalizedString} */ ("Caution")
});